
import { propsInstance } from "@/lib/util";
import { Component, MixedVue, mixins } from "@/vue";

const Props = propsInstance<{
  transitionName?: string;
  transitionDuration?: number;
  resetScroll?: boolean;
  allowOverflow?: boolean;
}>({
  transitionName: { type: String, default: "fade-carousel" },
  transitionDuration: { type: Number, default: 300 },
  resetScroll: { type: Boolean, default: false },
  allowOverflow: { type: Boolean, default: false },
});

@Component({
  name: "ContentTransition",
})
export default class ContentTransition extends mixins(MixedVue, Props) {
  $emit: {
    (e: "resize", size: { height: number; width: number }): any;
  };

  $el: HTMLDivElement;

  observer: MutationObserver = null;
  lastIndex: number = 0;

  mounted() {
    this.computeSize();
    window.addEventListener("resize", this.handleResize);
    this.observer = new MutationObserver(this.computeSize);
    this.observer.observe(this.$el, { childList: true, subtree: true });
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  computeSize() {
    let height: number = 0,
      width: number = 0;
    let child = this.$el.lastElementChild;
    if (child) {
      height = child.clientHeight;
      width = child.clientWidth;
    }
    this.$el.style.height = height + "px";
    this.$el.style.width = width + "px";
    this.$emit("resize", {
      height,
      width,
    });
    if (!child) {
      setTimeout(() => {
        this.$el.style.height = null;
        this.$el.style.width = null;
      }, this.transitionDuration);
    }
  }

  handleResize() {
    this.$el.style.transition = "none";
    this.$el.style.height = null;
    this.$el.style.width = null;
    this.computeSize();
    this.$el.style.transition = null;
  }

  beforeEnter(element: HTMLElement) {
    let index = parseInt(element.dataset?.index);
    if (index < this.lastIndex) {
      element.classList.add("inverse");
      let leaving = this.$el.firstElementChild;
      leaving.classList.add("inverse");
    }
  }

  enter(element: HTMLElement) {
    element.style.position = "absolute";
    if (this.resetScroll) {
      this.$el.scrollTop = 0;
      this.$el.scrollLeft = 0;
    }
  }

  afterEnter(element: HTMLElement) {
    element.style.position = null;
    this.lastIndex = parseInt(element.dataset.index);
    element.classList.remove("inverse");
  }

  leave(element: HTMLElement) {
    element.style.position = "absolute";
  }
}
